// 16:9 cover image, or a muted placeholder when the course has none.

import type { Course } from "../../types/course";

export function CourseCover({ course, small }: { course: Pick<Course, "imageUrl" | "title">; small?: boolean }) {
  const cls = `co-cover${small ? " sm" : ""}`;
  if (course.imageUrl) return <img className={cls} src={course.imageUrl} alt="" />;
  return (
    <div className={`${cls} empty`}>
      <span>No image</span>
    </div>
  );
}
